import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useSystemStore = defineStore('system', {
  state: () => ({
    subscription: null,
  }),
  getters: {
    getSubscription: function(state) {
      return state.subscription;
    },
  },
  actions: {
    onBoardTenant: function(payload) {
      return Api.system.onBoardTenant(payload);
    },
    getTenantEmails: function(contextNodeId) {
      return Api.system.getTenantEmails(contextNodeId);
    },
    saveTenantEmails: function(payload) {
      return Api.system.saveTenantEmails(payload.contextNodeId, payload.body);
    },
    validateTenantEmail: function(payload) {
      return Api.system.validateTenantEmail(payload.id, payload.code);
    },

    manageSubscriptionUrl: function(accessPointId) {
      return Api.system.manageSubscriptionUrl(accessPointId);
    },

    getBrandingInfo: function(payload) {
      return Api.system.getBrandingInfo(payload.nodeid);
    },
    saveBrandingInfo: function(payload) {
      return Api.system.saveBrandingInfo(payload.nodeid, payload.body);
    },
    deleteBrandLogo: function(payload) {
      return Api.system.deleteBrandLogo(payload.nodeid);
    },

    refreshSubscription: async function(contextNodeId, force = false) {
      if (force) {
        this.subscription = null;
      }

      const response = await Api.system.getSubscription(contextNodeId);
      this.subscription = response.data;
      return response.data;
    },
    subscribeForPlan(payload) {
      return Api.system.subscribeForPlan(payload.contextNodeId, payload.body);
    },
    buyAddons: function(payload) {
      return Api.system.buyAddons(payload.contextNodeId, payload.body);
    },

    updateTenantMFA: function(payload) {
      return Api.system.updateTenantMFA(payload);
    },
  },
});
